import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import PanelInfo from 'app/KinerjaPage/pages/PelaksanaanV2/components/PanelInfo'
import { SectionPanduanPenetapanPredikatKinerja } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PenetapanPredikatKinerja/SectionPanduanPenetapanPredikatKinerja'
import { Header } from 'app/KinerjaShared/components/Header'
import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import useSKPPelaksanaanTrackEvent from 'app/KinerjaPage/hooks/useSKPPelaksanaanTrackEvent'
import { getSatuanPendidikanByNpsn } from 'app/KinerjaShared/utils/profile'
import useDemoContext from 'app/KinerjaPage/hooks/useDemoContext'

interface PanduanPenetapanPredikatKinerjaProps {
  npsn?: string
}

export function PanduanPenetapanPredikatKinerja({
  npsn,
}: PanduanPenetapanPredikatKinerjaProps) {
  const { trackEvent } = useSKPPelaksanaanTrackEvent()
  const { profile, isLoading: isLoadingProfile } = useRoleContext()
  const { isDemoMode } = useDemoContext()

  return (
    <main className="px-8 pb-8 pt-12 bg-gray-10 min-h-full">
      <div className="max-w-7xl mx-auto space-y-5">
        <Header
          title="Panduan Penetapan Predikat Kinerja"
          className="mb-9"
          hideOnPrint
          rightNode={
            <PanelInfo
              isLoading={isLoadingProfile}
              label="Satuan Pendidikan"
              value={getSatuanPendidikanByNpsn(profile, npsn, isDemoMode)}
            />
          }
        />

        <SectionPanduanPenetapanPredikatKinerja
          actionNode={
            <Link
              href={`${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/penilaian-kinerja/${npsn}/daftar-guru/penetapan-predikat-kinerja`}
              passHref
            >
              <Button
                as="a"
                type={undefined}
                onClick={() => {
                  trackEvent({
                    activity_type: 'penilaian_ks_pk_click_lanjut_penetapan',
                    screen_name: 'ks_penetapan_kinerja',
                    event_trigger: 'ks_penilaian_hub',
                  })
                }}
              >
                Lanjut ke Penetapan
              </Button>
            </Link>
          }
          className="bg-white rounded-lg p-6"
          npsn={npsn}
          onPanduanClick={() => {
            trackEvent({
              activity_type: 'penilaian_ks_pk_click_baca_peraturan',
              screen_name: 'ks_penetapan_kinerja',
              event_trigger: 'ks_penilaian_hub',
            })
          }}
        />
      </div>
    </main>
  )
}
